import React from 'react';
import { Modal } from "@mui/material";

const RenameModal = ({ renameTarget, setRenameTarget, newTitle, setNewTitle, handleRenameAttendance }) => {
  return (
    <Modal open={!!renameTarget} onClose={() => setRenameTarget(null)}>
      <div className="renameModalContainer">
        <h3>Redenumește ședința</h3>
        <input 
          type="text" 
          className="renameInput"
          value={newTitle}
          onChange={(e) => setNewTitle(e.target.value)}
          autoFocus
        />
        <div className="renameModalButtons">
          <button 
            className="renameConfirmBtn"
            onClick={() => handleRenameAttendance(renameTarget, newTitle)}
          >
            Salvați
          </button>
          <button 
            className="renameCancelBtn"
            onClick={() => setRenameTarget(null)}
          >
            Anulați
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default RenameModal;
